import ResultsLabel from './ResultsLabel';
import TotalResults from './TotalResults';

export { ResultsLabel, TotalResults };
